import { createPortal } from 'react-dom';
import { useToast } from './ToastContext';

// =========================================================================
// ToastHost — renders the queue. Mounted once, in app/layout.tsx.
//
// Portalled to <body> so it clears the shell's overflow clipping and the
// drawer backdrop. `aria-live="polite"` on a container that is always in the
// DOM: screen readers only announce mutations inside a live region that
// already existed, so the region cannot be conditional on there being toasts.
//
// Colour comes entirely from theme tokens — this file has no hex, per the
// global.css hex-free rule.
// =========================================================================

export function ToastHost() {
  const { toasts, dismiss } = useToast();

  if (typeof document === 'undefined') return null;

  return createPortal(
    <div
      aria-live="polite"
      aria-atomic="false"
      className="pointer-events-none fixed inset-x-0 bottom-6 z-[300] flex flex-col items-center gap-2 px-4"
    >
      {toasts.map((toast) => (
        <button
          key={toast.id}
          type="button"
          onClick={() => dismiss(toast.id)}
          className="pointer-events-auto max-w-[min(520px,calc(100vw-2rem))] rounded-xl px-4 py-2.5 text-left text-sm shadow-lg backdrop-blur-xl transition-opacity hover:opacity-90"
          style={{
            background: 'var(--glass-surface-strong)',
            border: '1px solid var(--glass-border-strong)',
            color: 'var(--ink-primary)',
            boxShadow: '0 12px 32px -12px var(--shadow-warm-lg)',
          }}
        >
          {toast.message}
        </button>
      ))}
    </div>,
    document.body,
  );
}
